import { useMobile } from '@verifime/utils';
import Link from 'next/link';
import { ReactNode } from 'react';
import { UrlObject } from 'url';
import { TNavItem } from '../types';
import { urlObjectToString } from './navUtils';
import SideNavLogo from './SideNavLogo';

export type THomeLinkProps = {
  homeNavItem: TNavItem;
  navItemHrefProcessor?: (href: UrlObject) => UrlObject;
  /**
   * Custom logo component to display in the home link.
   * Defaults to the VerifiMe Logo if not provided.
   */
  logo?: ReactNode;
};

export default function HomeLink({
  homeNavItem,
  navItemHrefProcessor = (href) => href,
  logo,
}: THomeLinkProps) {
  const isMobile = useMobile();

  const renderLogo = () => {
    if (logo) {
      // When a custom logo is provided, render it directly without wrapping in SideNavLogo
      // This avoids double-wrapping with background styling
      return logo;
    }
    if (isMobile) {
      return <SideNavLogo size="small" layout="markOnly" />;
    }
    return <SideNavLogo />;
  };

  const processed = homeNavItem
    ? navItemHrefProcessor({ pathname: homeNavItem.path })
    : { pathname: '#' };

  if (homeNavItem?.external === true) {
    return <a href={urlObjectToString(processed)}>{renderLogo()}</a>;
  }

  return <Link href={processed}>{renderLogo()}</Link>;
}
